module.exports = __webpack_public_path__ + "img/idn.17b99676.svg";